<h3>MEMBER FILE: <span class="header--accent">{{ memberDetail.memberName }}</span></h3>
<div class="item-container"> 
  <app-list [items]="memberItems"></app-list>
</div>